module.exports = __webpack_public_path__ + "img/app-store-badge@2x.3d0733de.png";